export enum loginTags {
  titlePage = 'Inicio de sesión',
  usernamePlaceholder = 'Nombre de usuario',
  passwordPlaceholder = 'Contraseña',
  loginButton = 'Iniciar sesión'
}
